// The `new URL(..., import.meta.url)` form is how webpack finds and bundles the
// worker into its own chunk. It lives alone in this module because Jest's Babel
// config can't parse `import.meta` — tests mock this file instead.

export default function createTranscribeWorker() {
  return new Worker(new URL('./transcribeWorker.js', import.meta.url));
}
